import { Flex, useTheme, spacing } from '@fti/design-system';

interface ProgressBarProps {
  value: number;
  size?: 'sm' | 'md' | 'lg';
  color?: 'primary' | 'success' | 'warning' | 'error';
  showLabel?: boolean;
  label?: string;
}

const HEIGHT_MAP = { sm: 6, md: 10, lg: 16 };

export function ProgressBar({
  value,
  size = 'md',
  color = 'primary',
  showLabel = false,
  label,
}: ProgressBarProps) {
  const { theme } = useTheme();
  const percent = Math.min(100, Math.max(0, value));
  const height = HEIGHT_MAP[size];

  const barColor =
    color === 'primary'
      ? theme.colors.primary[500]
      : theme.colors.semantic[color]?.default ?? theme.colors.primary[500];

  const trackColor = theme.colors.neutral[200];

  return (
    <Flex align="center" gap="sm" style={{ width: '100%' }}>
      <div
        style={{
          flex: 1,
          height,
          backgroundColor: trackColor,
          borderRadius: height / 2,
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            width: `${percent}%`,
            height: '100%',
            backgroundColor: barColor,
            borderRadius: height / 2,
            transition: 'width 0.3s ease',
          }}
        />
      </div>
      {showLabel && (
        <span
          style={{
            fontSize: size === 'sm' ? '0.7rem' : '0.8rem',
            color: theme.colors.text.secondary,
            minWidth: 40,
            textAlign: 'right',
          }}
        >
          {label ?? `${Math.round(percent)}%`}
        </span>
      )}
    </Flex>
  );
}
